module.exports = __webpack_public_path__ + "img/selected2-min.d96cbc20.png";